import * as CONFIG from '@/config';
/**
 * 获取官网地址
 * @param path
 * @returns
 */
export function getOfficialSitePath(path?: string): string {
    return CONFIG.OFFICIAL_DOMAIN + (path ?? '');
}

/**
 * 获取退出登录地址
 * @param redirect
 * @returns.
 */
export function getLogoutPath(redirect?: string): string {
    return `${CONFIG.MY_ACCOUNT}/logout/${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`;
}

/**
 * 获取登录地址
 * @param redirect
 * @returns.
 */
export function getLoginPath(redirect?: string): string {
    return `${CONFIG.MY_ACCOUNT}/login/${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`;
}

/**
 * 获取注册地址
 * @param redirect
 * @returns.
 */
export function getSignupPath(redirect?: string): string {
    return `${CONFIG.MY_ACCOUNT}/login/${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}#signup`;
}

/**
 * 获取账户中心地址
 * @param path
 * @returns
 */
export function getAccountCenterPath(path?: string): string {
    return CONFIG.MY_ACCOUNT + (path ?? '');
}

/**
 * 获取云服务地址
 * @param path
 * @returns
 */
export function getCloudPath(path?: string): string {
    return CONFIG.REO_CLOUD_DOMAIN + (path ?? '');
}

/**
 * 获取社区地址
 * @param path
 * @returns
 */
export function getCommunityPath(path?: string): string {
    return CONFIG.REO_COMMUNITY_DOMAIN + (path ?? '');
}

/**
 * 获取Support地址
 * @param path
 * @returns
 */
export function getSupportPath(path?: string): string {
    return CONFIG.REO_SUPPORT_DOMAIN + (path ?? '');
}

/**
 * 获取Store地址
 * @param path
 * @returns
 */
export function getStorePath(path?: string): string {
    return CONFIG.REO_STORE_DOMAIN + (path ?? '');
}
